module.exports = __webpack_public_path__ + "static/media/boat-img-1.6d2c7ba8.jpg";